import React from 'react'
import { Modal, Row, Col } from 'antd'
import styled from 'styled-components'
import { SecondaryButton, PrimaryButton } from 'Components/Shared/Button'

type Props = {
  onClose: () => void
  onSubmit: () => void
  visible?: boolean
  title?: string
  desc?: string
}

const ConfirmDeleteModal = (props: Props) => {
  const { visible = false, onClose, onSubmit, title = '', desc = '' } = props

  return (
    <Modal
      className="add-modal"
      title={false}
      centered
      visible={visible}
      footer={false}
      closable={false}
    >
      <Body>
        <Header>{title}</Header>
        {desc && <Desc>{desc}</Desc>}
        <ButtonSection>
          <Row type="flex" justify="end">
            <Col>
              <div className="btn-submit">
                <SecondaryButton
                  text="ยกเลิก"
                  disabled={false}
                  onClick={() => onClose()}
                />
              </div>
            </Col>
            <Col>
              <div className="btn-submit">
                <PrimaryButton text="บันทึก" onClick={onSubmit} />
              </div>
            </Col>
          </Row>
        </ButtonSection>
      </Body>
    </Modal>
  )
}

const Header = styled.div`
  text-align: left;
  font-family: 'DB Helvethaica X 75 Bd';
  font-size: 24px;
  color: #000;
`

const Desc = styled.div`
  text-align: left;
  font-family: 'DB Helvethaica X 55 Regular';
  font-size: 20px;
  color: #000;
`

const Body = styled.div``

const Input = styled.div`
  margin-top: 10px;
`

const ButtonSection = styled.div`
  margin-top: 32px;
  .btn-submit {
    width: 132px;
    margin-left: 16px;
  }
`

export default ConfirmDeleteModal
